<template>
  <div>
  <el-dialog top="3vh" :visible.sync="visible" width="80%"
             :close-on-click-modal="true"
             :close-on-press-escape="true" @closed="closedHandler" center>
    <h3 slot="title">Assign Permission to Role: {{ role.name }}</h3>
    <el-row>
      <el-col :span="18" :offset="6">
        <el-transfer
            filterable
            :titles="['Permissions', 'Assigned Perms']"
            v-model="assigned"
            :data="unassigned">
        </el-transfer>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer">
      <el-button @click.prevent="visible = false">Cancel <i class="el-icon-close"></i></el-button>
      <el-button :loading="loading" type="primary" @click="saveChanges">Save Changes <i class="el-icon-circle-check-outline"></i></el-button>
    </div>
  </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'role-assign-permission-modal',
  props: ['role'],
  data () {
    return {
      visible: true,
      assigned: [],
      unassigned: [],
      loading: false
    }
  },
  methods: {
    withLoading (fn, loadingKey = 'loading') {
      this[loadingKey] = true
      return fn().finally(() => {
        this[loadingKey] = false
      })
    },
    showSuccess (message) {
      this.$message.success(message)
    },
    showError (message) {
      this.$message.error(message)
    },
    closedHandler () {
      this.$emit('close')
    },
    async getPermissions () {
      try {
        const res = await this.$permissionService.getPermissions()
        this.unassigned = (res || []).map(p => ({
          label: p.name,
          key: p.id,
          initials: p.name,
          guard_name: p.guard_name || 'api'
        }))
      } catch (error) {
        console.error('Error loading permissions:', error)
        this.unassigned = []
        const errorMessage = error.response?.data?.message || error.message || 'Failed to load permissions. Please try again.'
        this.showError(errorMessage)
      }
    },
    async getRolePermissions () {
      if (!this.role || !this.role.id) {
        console.error('Invalid role provided')
        this.assigned = []
        return
      }

      try {
        const res = await this.$roleService.getRolePermissions(this.role.id)
        this.assigned = (res || []).map(p => p.id).filter(id => id != null)
      } catch (error) {
        console.error('Error loading role permissions:', error)
        this.assigned = []
        const errorMessage = error.response?.data?.message || error.message || 'Failed to load role permissions. Please try again.'
        this.showError(errorMessage)
      }
    },
    async saveChanges () {
      if (!this.role || !this.role.id) {
        this.showError('Invalid role selected')
        return
      }

      try {
        await this.withLoading(async () => {
          await this.$roleService.assignPermissions(this.role.id, {
            permissions: this.assigned || []
          })
          this.showSuccess(
            this.$t('role.message.permission_assigned')?.toString() || 'Permissions assigned successfully'
          )
          this.$emit('permissions-updated', { roleId: this.role.id, permissions: this.assigned })
          this.closedHandler()
        }, 'loading')
      } catch (error) {
        console.error('Error assigning permissions:', error)
        const errorMessage = error.response?.data?.message || error.message || 'Failed to assign permissions. Please try again.'
        this.showError(errorMessage)
      }
    }
  },
  async mounted () {
    // Load both in parallel, but handle errors independently
    await Promise.allSettled([
      this.getRolePermissions(),
      this.getPermissions()
    ])
  }
}
</script>
<style scoped>

</style>
